import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ManageCentersService } from 'src/app/private/services/manage-centers.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-manage-centers',
  templateUrl: './manage-centers.component.html',
  styleUrls: ['./manage-centers.component.scss']
})
export class ManageCentersComponent implements OnInit {

  displayedColumns: string[] = ['name', 'description', 'action'];
  dataSource = new MatTableDataSource<any>();
  isLoading = false;
  btnLoading = false;
  formAction = 'Add';
  selectedCenter: any = {};
  center: Center = new Center();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private api: ManageCentersService,
    private modalService: NgbModal,
    private toast: ToastrService,
    private localStorage: LocalStorageService
  ) { }

  ngOnInit(): void {
    this.loadCenters();
  }

  loadCenters() {
    this.isLoading = true;
    const param = {
      where: {
        client_id: this.localStorage.getClientId()
      }
    };
    this.api.getAllCenter(param).subscribe({
      next: (res: any) => {
        this.dataSource.data = res || [];
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.isLoading = false;
      },
      error: (err: any) => {
        this.isLoading = false;
        console.error(err);
        this.toast.error('Error loading centers');
      }
    });
  }

  open(content: any, center: any = null) {
    if (center) {
      this.formAction = 'Edit';
      this.center = { ...center }; 
    } else {
      this.formAction = 'Add';
      this.center = new Center();
      this.center.client_id = this.localStorage.getClientId();
    }
    this.modalService.open(content, { size: 'lg', centered: true });
  }

  save() {
    if (!this.center.center_name) {
      this.toast.error('Center Name is required');
      return;
    }

    this.btnLoading = true;
    
    // Ensure client_id is set
    this.center.client_id = this.localStorage.getClientId();

    if (this.formAction === 'Add') {
      this.api.createCenter(this.center).subscribe({
        next: () => {
          this.toast.success('Center created successfully');
          this.modalService.dismissAll();
          this.loadCenters();
          this.btnLoading = false;
        },
        error: (err) => {
          this.toast.error(err.error?.msg || 'Error creating center');
          this.btnLoading = false;
        }
      });
    } else {
      this.api.updateCenter(this.center).subscribe({
        next: () => {
          this.toast.success('Center updated successfully');
          this.modalService.dismissAll();
          this.loadCenters();
          this.btnLoading = false;
        },
        error: (err) => {
          this.toast.error(err.error?.msg || 'Error updating center');
          this.btnLoading = false;
        }
      });
    }
  }

  deleteModal(content: any, center: any) {
    this.selectedCenter = center;
    this.modalService.open(content, { centered: true });
  }

  deleteCenter() {
    this.btnLoading = true;
    const param = {
      center_id: this.selectedCenter.center_id
    };
    this.api.deleteCenter(param).subscribe({
      next: () => {
        this.toast.success('Center deleted successfully');
        this.modalService.dismissAll();
        this.loadCenters();
        this.btnLoading = false;
      },
      error: (err) => {
        this.toast.error(err.error?.msg || 'Error deleting center');
        this.btnLoading = false;
      }
    });
  }
}

export class Center {
  center_id?: number;
  center_name: string = "";
  description: string = "";
  client_id: any;
  status: string = "Active";
}
